import Rollbar from "rollbar"

const IGNORED = [
  /ResizeObserver loop/,
  /Non-Error promise rejection captured/,
  /^Script error\.?$/,
  /Failed to fetch/,
  /Load failed/,
  /NetworkError when attempting to fetch resource/,
  /AbortError|aborted/,
  /Java object is gone/
]

const BOT_AGENT = /Google-Read-Aloud|Lighthouse|HeadlessChrome|bot|crawler|spider/i
const IOS_CHROME = /CriOS/
const INJECTED_FRAME = /^iabjs:\/\//

const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content

const person = () => {
  const id = meta("current-user-id")
  return id ? { id } : {}
}

const frames = (item) => {
  const traces = item.body?.trace_chain || [item.body?.trace].filter(Boolean)
  return traces.flatMap((trace) => trace.frames || [])
}

const messages = (item) => [
  item.message,
  item.err?.message,
  ...frames(item).map((frame) => frame.filename)
].filter(Boolean)

const checkIgnore = (isUncaught, args, item) => {
  const text = messages(item).join(" ")
  if (INJECTED_FRAME.test(text) || frames(item).some((frame) => INJECTED_FRAME.test(frame.filename))) return true
  if (IOS_CHROME.test(navigator.userAgent) && /Maximum call stack size exceeded/.test(text)) return true

  return false
}

const reportBrokenImages = (rollbar) => {
  document.addEventListener(
    "error",
    (event) => {
      const element = event.target
      if (!element || element.tagName !== "IMG") return
      if (!element.getAttribute("src")) return
      if (!navigator.onLine) return

      rollbar.warning("Image failed to load", {
        src: element.currentSrc || element.src,
        page: window.location.pathname
      })
    },
    true
  )
}

export const startErrorReporting = () => {
  const token = meta("rollbar-token")
  if (!token) return
  if (BOT_AGENT.test(navigator.userAgent)) return

  const rollbar = new Rollbar({
    accessToken: token,
    captureUncaught: true,
    captureUnhandledRejections: true,
    ignoredMessages: IGNORED.map((pattern) => pattern.source),
    checkIgnore,
    payload: {
      environment: meta("app-env") || "production",
      person: person()
    }
  })

  window.Rollbar = rollbar
  reportBrokenImages(rollbar)
}
